import s from "./styles.module.sass";

const OurVision = () => {
	return (
		<section className={`${s.ourVision} marginedSection`}>
			<div className={s.image} />
			<div className={s.info}>
				<h3 className={s.title}>В чем наша ценность?</h3>
				<p>
					В классическом образовании слишком много «надо» и слишком мало «хочется».
					<br />
					Мы верим, что потенциал человека раскрывается, когда он искренне наслаждается изучением незнакомого
					предмета и развитием новых навыков.
				</p>
			</div>
		</section>
	);
};

export default OurVision;
